module.exports = __webpack_public_path__ + "img/3.dcd1a29f.jpg";